import { IResultDetail } from '@app/api/result.api';
import { Descriptions } from 'antd';
import { Table } from 'components/common/Table/Table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SpeakReadAloudProps {
  data: IResultDetail;
}

interface Column {
  title: string;
  dataIndex: string;
  key?: string;
}

export const ListenText: React.FC<SpeakReadAloudProps> = ({ data }) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<Column[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataScore, setDataScore] = useState([{ key: 1, content: 0, form: 0, grammar: 0, spelling: 0, total: 0 }]);

  useEffect(() => {
    setColumns([
      { title: t('page.results.detailTable.content'), dataIndex: 'content', key: 'content' },
      { title: t('page.results.detailTable.form'), dataIndex: 'form', key: 'form' },
      { title: t('page.results.detailTable.grammar'), dataIndex: 'grammar', key: 'grammar' },
      { title: t('page.results.detailTable.spelling'), dataIndex: 'spelling', key: 'spelling' },
      { title: t('page.results.detailTable.total'), dataIndex: 'total', key: 'total' },
    ]);
  }, [t]);

  return (
    <Descriptions bordered column={1} title={t('page.results.answerDetail')} size="small">
      <Descriptions.Item label={<span style={{ whiteSpace: 'nowrap' }}>{t('page.results.correctAnswer')}</span>}>
        {data.correct_answer}
      </Descriptions.Item>
      <Descriptions.Item label={<span style={{ whiteSpace: 'nowrap' }}>{t('page.results.yourAnswer')}</span>}>
        {data.your_answer}
      </Descriptions.Item>
      <Descriptions.Item label={t('page.results.score')}>
        <Table columns={columns} dataSource={dataScore} scroll={{ x: 800 }} pagination={false} />
      </Descriptions.Item>
    </Descriptions>
  );
};
